import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

export const SUPPORTED_LANGS = ['en', 'ar', 'fr', 'es', 'it', 'de']

const toSupportedLang = lng => {
  const base = String(lng || '').split('-')[0].toLowerCase()
  return SUPPORTED_LANGS.includes(base) ? base : 'en'
}

const context = require.context('./locales', true, /\.json$/)
const resources = {}
context.keys().forEach(key => {
  const segments = key.split('/').filter(Boolean)
  const file = segments.pop() || ''
  const lang = segments.pop()
  if (!lang || !SUPPORTED_LANGS.includes(lang) || !file.endsWith('.json')) return
  const ns = file.replace(/\.json$/, '')
  resources[lang] = resources[lang] || {}
  resources[lang][ns] = context(key)
})

const namespaces = [...new Set(Object.values(resources).flatMap(r => Object.keys(r)))]

// Arabic-only shareable URLs: /ar/... forces Arabic regardless of stored/device language.
const getPathLang = () => {
  if (typeof window === 'undefined') return undefined
  const path = window.location.pathname
  return path === '/ar' || path.startsWith('/ar/') ? 'ar' : undefined
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: getPathLang(),
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS,
    load: 'languageOnly',
    ns: namespaces,
    defaultNS: 'common',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: [],
      lookupLocalStorage: 'peaks_lang',
      convertDetectedLanguage: toSupportedLang
    }
  })

const syncHtmlLangDir = () => {
  const lang = i18n.resolvedLanguage || i18n.language || 'en'
  const dir = lang === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.setAttribute('lang', lang)
  document.documentElement.setAttribute('dir', dir)
}

syncHtmlLangDir()
i18n.on('languageChanged', syncHtmlLangDir)

export default i18n
